module.exports = __webpack_public_path__ + "static/media/wizard-form.6d6c98b0.jpg";